import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-sand py-16 sm:py-20" aria-labelledby="faq-heading" data-id="element-48" data-mp="1bl23p9e8x8f0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-49" data-mp="1gjc0fofmch2q">
        <div className="text-center" data-id="element-50" data-mp="1gketo30eyvlt">
          <p className="eyebrow text-sage-deep" data-id="element-51" data-mp="1glgbqrfukid1">Before you decide</p>
          <h2 id="faq-heading" className="mt-5 font-display text-[2rem] leading-[1.12] text-ink sm:text-4xl" data-id="element-52" data-mp="249pshey7efxb">
            Frequently asked questions
          </h2>
        </div>

        <ul className="mt-12 space-y-2.5" data-id="element-53" data-mp="1uiblyn7u4fuo">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-3xl border bg-shell transition-colors duration-150 ease-out ${isOpen ? 'border-sage/45' : 'border-line'}`} data-id="element-54" data-mp="1zgd5tad34j77" data-mpi={index}>
                <h3 data-id="element-55" data-mp="2rzk7a2232ek7">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-3xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sage" data-id="element-56" data-mp="2s03f2py0rmki">
                    <span className="font-display text-lg leading-snug text-ink sm:text-xl" data-id="element-57" data-mp="19tvc1x7wbgqt">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-sage text-ivory' : 'bg-sage-light text-sage-deep'}`} aria-hidden="true" data-id="element-58" data-mp="1oldz2ez6abjo">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-59" data-mp="1sl4ly7lkw7ix" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-60" data-mp="3uchq2ufq2bdx">
                  <div className="overflow-hidden" data-id="element-61" data-mp="237xxpaw4o8qr">
                    <p className="px-6 pb-6 font-sans text-[0.93rem] leading-relaxed text-stone" data-id="element-62" data-mp="238g593o8q9dz">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}